module.exports = __webpack_public_path__ + "img/1.95913b48.png";